import { Col, NewsBox, Text } from 'components';
import parse from 'html-react-parser';
import { Api, formatLocale, theme } from 'lib';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Loading } from 'screens/Website/Home/components';
import styled from 'styled-components';

const Header = styled.div`
  height: 510px;
  width: 100%;
  background-color: ${theme.DARK_PURPLE};
  display: flex;
  flex-direction: column;
  margin-top: 60px;

  @media (max-width: 1024px) {
    height: unset;

    .mobile-img-header > div {
      margin: 17px 14px;
    }
  }

  @media (min-width: 1024px) {
    .mobile-img-header {
      display: none;
    }
  }
`;

const HeaderContent = styled.div`
  width: 1140px;
  align-self: center;
  display: flex;

  @media (max-width: 1024px) {
    width: 100%;
    flex-direction: column;
  }
`;

const MainImage = styled.div`
  background-image: url(${(props) => props.img});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  height: 570px;
  width: 570px;
  margin-top: -30px;

  @media (max-width: 1024px) {
    width: 100%;
    height: 100vw;
    margin-top: unset;
  }
`;

const HeaderTextsContainer = styled.div`
  flex: 1;
  height: 100%;

  h5 {
    font-size: 24px;
    color: ${theme.SECONDARY};
  }

  h1 {
    font-size: 40px;
    color: ${theme.PRIMARY_WHITE};
  }

  .date-text {
    font-size: 20px;
    color: ${theme.PRIMARY_WHITE};
  }

  .subtitle {
    margin-top: 45px;
    font-size: 28px;
    color: ${theme.PRIMARY_WHITE};
  }

  div {
    margin: 32px 0 32px 21px;
  }

  @media (max-width: 1024px) {
    width: 100vw;
    height: unset;

    h5 {
      font-size: 18px;
    }

    h1 {
      font-size: 36px;
    }

    .date-text {
      font-size: 18px;
    }

    .subtitle {
      font-size: 18px;
    }

    div {
      margin: 21px 16px 32px 16px;
    }
  }
`;

const ArticleContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  div {
    width: 701px;
    align-self: center;
    margin: 84px 0;

    h3,
    h2,
    h1 {
      font-weight: 500;
      font-size: 24px;
    }

    p {
      font-size: 20px;
    }
  }

  @media (max-width: 1024px) {
    div {
      width: unset;
      padding: 0 17px;
      margin: 59px 0 54px;

      h3,
      h2,
      h1 {
        font-size: 20px;
      }

      p {
        font-size: 14px;
      }
    }
  }
`;

const RelatedArticles = styled.div`
  width: 1140px;
  align-self: center;
  margin: 20px 0;

  .related-articles-container {
    display: flex;
    justify-content: space-between;
  }

  .related-articles-text {
    font-size: 20px;
  }

  @media (max-width: 1024px) {
    width: 100vw;

    .related-articles-text {
      font-size: 16px;
      padding: 0 17px;
    }

    .related-articles-container {
      overflow-y: scroll;
      width: unset;

      .article-box {
        margin-right: 16px;
      }
    }
  }
`;

const NewsArticle = (props) => {
  const [article, setArticle] = useState(null),
    [relatedArticles, setRelatedArticles] = useState(null),
    { articleId } = useParams();

  useEffect(() => {
    if (!articleId) return;

    setArticle(null);
    fetchArticle();
  }, [articleId]);

  async function fetchArticle() {
    const res = await Api.get(`/articles/getOne/${articleId}`);
    if (!res) return;

    setArticle(res.article);
    setRelatedArticles(res.relatedArticles);
  }

  return (
    <React.Fragment>
      <Loading isLoading={!article} />

      {article && (
        <Col>
          <Header>
            <HeaderContent>
              <MainImage img={article.images?.mainBig || require('assets/images/pogba.png')}>
                <HeaderTextsContainer className="mobile-img-header">
                  <div>
                    <Text h5>{article.sport.toUpperCase()}</Text>

                    <Text h1>{article.title.toUpperCase()}</Text>

                    <Text className="date-text">
                      {formatLocale(new Date(article.createdAt), 'dd MMM yyy')}
                    </Text>
                  </div>
                </HeaderTextsContainer>
              </MainImage>

              <HeaderTextsContainer>
                <div>
                  <Text h5>{article.sport.toUpperCase()}</Text>

                  <Text h1>{article.title.toUpperCase()}</Text>

                  <Text className="date-text">
                    {formatLocale(new Date(article.createdAt), 'dd MMM yyy')}
                  </Text>

                  <Text className="subtitle">{article.subTitle}</Text>
                </div>
              </HeaderTextsContainer>
            </HeaderContent>
          </Header>

          <ArticleContainer>
            <div>{parse(article.body)}</div>
          </ArticleContainer>

          <RelatedArticles>
            <Text className="related-articles-text" med>
              Related Articles
            </Text>

            <div className="related-articles-container">
              {relatedArticles?.map((art, i) => (
                <NewsBox item={art} i={i} key={i} />
              ))}
            </div>
          </RelatedArticles>
        </Col>
      )}
    </React.Fragment>
  );
};

// img={`url(${article?.images?.mainBig})` || require('assets/images/pogba.png')}

export default NewsArticle;
